export const useSxStyles = () => {
  return {
    content: {
      display: 'grid',
      padding: 0,
    },
    btnLeftMargin: {
      marginLeft: '5px',
    },
  };
};
